module.exports = __webpack_public_path__ + "img/Bermuda.0c4365b2.png";